export const InterventionalStudyOptionsConstant = [
    { label: 'Single Group', value: 'SingleGroup' },
    { label: 'Parallel Group', value: 'ParallelGroup' },
    { label: 'Parallel Group Randomized', value: 'ParallelGroupRandomized' },
    { label: 'Parallel Group Non-Randomized', value: 'ParallelGroupNonRandomized' },
    { label: 'Crossover', value: 'Crossover' },
];
